export default __webpack_public_path__ + "static/media/hackathonImage.9c7eb695.svg";